import { isObject } from "lodash";

export module ioGuid {
    export function New() {
        return 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

}


export module ioRandom {
    export function number(_maxNumber = 10000000000) {
        return Math.floor((Math.random() * _maxNumber) + 1);
    }
    export function string(_length = 5) {
        let text = '';
        const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

        for (let i = 0; i < _length; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }
}


export module QueryParamsOLD {
    export function stringify(_obj: {}) {
        const str = [];
        for (const p in _obj) {
            if (_obj.hasOwnProperty(p) && _obj[p] !== null && _obj[p] !== '') {
                str.push(encodeURIComponent(p) + '=' + encodeURIComponent(_obj[p]));
            }
        }
        return str.join('&');
    }

    export function getUrlParam(name): any {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)')
            .exec(window.location.search);
        return (results !== null) ? results[1] || 0 : '';

    };

}

//UNTESTED WITH ARRAYS
//TODO: check with days
export module QueryParams {
    export function stringify(_obj: {}) {
        const str = [];
        for (const p in _obj) {

            if (_obj[p] instanceof Array) {
                for (let i = 0; i < _obj[p].length; i++) {
                    let innerObj = _obj[p][i];
                    if (isObject(innerObj)){
                        for (const k in innerObj) {
                            if (innerObj.hasOwnProperty(k) && innerObj[k] !== null && innerObj[k] !== '') {
                               str.push(encodeURIComponent(p) + '[' + [i] + ']' + '[' + encodeURIComponent(k) + ']' + '=' + encodeURIComponent(innerObj[k]));
                            }
                        }
                    } else {
                        str.push(encodeURIComponent(p) + '[' + [i] + ']' + '=' + encodeURIComponent(innerObj))
                    }
                }
            } 
            //else if (_obj[p] instanceof Object) {
              //  str.push(encodeURIComponent(p) + '=' + JSON.stringify(_obj[p]))
            //}
             else {

                if (_obj.hasOwnProperty(p) && _obj[p] !== null && _obj[p] !== '') {
                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(_obj[p]));
                }

            }

        }
        return str.join('&');
    }


    export function getUrlParam(name): any {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)')
            .exec(window.location.search);
        return (results !== null) ? results[1] || 0 : '';

    };

}


export module ioRegExp {
    export function escapeRegExp(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&').trim();
    }
}

export module ioDate {


    export function addDays(_days, newdate: Date = new Date()) {
        newdate.setDate(newdate.getDate() + _days);
        const dd = newdate.getDate();
        const mm = newdate.getMonth();
        const y = newdate.getFullYear();
        return new Date(y, mm, dd);
    }


    export function getDataDiff(startDate, endDate) {
        var diff = endDate.getTime() - startDate.getTime();
        var days = Math.floor(diff / (60 * 60 * 24 * 1000));
        var hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
        var minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));
        var seconds = Math.floor(diff / 1000) - ((days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60));
        return { day: days, hour: hours, minute: minutes, second: seconds };
    }

}

export module ioSortData {

    export function ByValue(_array, _fieldname) {
        let data = _array
        data.sort(function (a, b) {
            var Value = a[_fieldname].toLowerCase(), Value2 = b[_fieldname].toLowerCase();
            if (Value < Value2) return -1;
            if (Value > Value2) return 1;
            return 0;
        });

        return data;
    }

    export function ByDate(_array, _fieldname, _orderby: "asc" | "desc") {

        let data = _array

        switch (_orderby) {

            case 'asc': {
                data.sort(function (a, b) {
                    var dateA = new Date(a[_fieldname]), dateB = new Date(b[_fieldname]);
                    return dateA.getTime() - dateB.getTime();
                });
                break;
            }

            case 'desc': {
                data.sort(function (a, b) {
                    var dateA = new Date(a[_fieldname]), dateB = new Date(b[_fieldname]);
                    return dateB.getTime() - dateA.getTime();
                });
                break;
            }
        }

        return data;
    }

}






